// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponGetEnrollmentDetailsDefaultResponseData {
    static getAttributeTypeMap() {
        return CouponGetEnrollmentDetailsDefaultResponseData.attributeTypeMap;
    }
}
CouponGetEnrollmentDetailsDefaultResponseData.discriminator = undefined;
CouponGetEnrollmentDetailsDefaultResponseData.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "cardStartDate",
        "baseName": "cardStartDate",
        "type": "Date"
    },
    {
        "name": "cardEndDate",
        "baseName": "cardEndDate",
        "type": "Date"
    },
    {
        "name": "cardActivationDate",
        "baseName": "cardActivationDate",
        "type": "Date"
    },
    {
        "name": "eligibilityStatusCode",
        "baseName": "eligibilityStatusCode",
        "type": "TCSEligibilityStatus"
    },
    {
        "name": "eligibilityStatusDescription",
        "baseName": "eligibilityStatusDescription",
        "type": "string"
    },
    {
        "name": "eligibilityDate",
        "baseName": "eligibilityDate",
        "type": "Date"
    },
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "sponsorNumber",
        "baseName": "sponsorNumber",
        "type": "string"
    },
    {
        "name": "alternateCardIds",
        "baseName": "alternateCardIds",
        "type": "Array<EnrollmentAlternateCardId>"
    },
    {
        "name": "groupNumber",
        "baseName": "groupNumber",
        "type": "string"
    },
    {
        "name": "totalBenefitAmount",
        "baseName": "totalBenefitAmount",
        "type": "number"
    },
    {
        "name": "remainingBenefitAmount",
        "baseName": "remainingBenefitAmount",
        "type": "number"
    },
    {
        "name": "totalPaidAmount",
        "baseName": "totalPaidAmount",
        "type": "number"
    },
    {
        "name": "communicationTypes",
        "baseName": "communicationTypes",
        "type": "TCSCommunicationType"
    }
];
//# sourceMappingURL=couponGetEnrollmentDetailsDefaultResponseData.js.map